import m from "../../es2015/lang/vi_VN";
window.am4lang_vi_VN = m;


//////////////////
// WEBPACK FOOTER
// ./lang/vi_VN.js
// module id = null
// module chunks = 